<template>
  <div>
    <spinner-round :isLoading="loading"></spinner-round>
    <div v-if="option && !loading">
      <sticky class="page-header sticky-page-header page-header--new">
        <div slot="left">
          <h1 class="title is-4">
            <span class="is-uppercase">Passage en réservation</span>
            <span class="has-text-weight-bold is-uppercase">
              <router-link :to="{'name': 'LotVue', params: {id: lot.pk}}" v-if="lot && lot.pk"
                           class="is-padding-right-xsmall">
                - Lot {{lot.ref}}
              </router-link>
              <router-link :to="{'name': 'ProgramVue', params: {id: program.pk}}" v-if="program && program.pk">
                - {{program.name}}
              </router-link></span>
          </h1>
        </div>
      </sticky>
      <div class="is-padding-left-on-btn-actions is-padding-right-on-btn-actions ">
        <div
          class="has-bg-brand is-padding-left-xlarge is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
          <div class="is-margin-left-large has-text-white is-size-6">
            <span class="icon is-size-7 is-small"><i class="fas fa-check-circle fa-xs"></i></span><i>Information
            obligatoire pour la validation du formulaire</i>
          </div>
        </div>

        <div class="columns is-gapless is-multiline is-margin-neg-left-xxsmall is-margin-neg-right-xxsmall">
          <div class="column is-12 is-7-widescreen is-7-fullhd is-padding-left-xxsmall is-padding-right-xxsmall">
            <div class="is-border has-bg-white is-height-full">

              <div class="columns has-bg-light">

                <div class="column is-3">
                  <div class="is-margin-bottom-xsmall">
                    <r-label :label="`Taux de commercialisation`" :redCheck='true'
                             :value="adv.program_remuneration"></r-label>
                  </div>
                  <div class="field has-addons">
                    <v-input id="remuneration"
                             :name="'remuneration'"
                             @input="val => adv.program_remuneration = Number(val)"
                             :model="adv.program_remuneration"
                             :errors-bag="errors"
                             data-vv-value-path="val"
                             classes="has-text-centered"
                             :max="100" :number="true"
                             input-type="number"
                             data-vv-as=" "
                             icon="fa-percentage"
                             v-validate="'required|decimal:2'"
                             :hasIncrementations="true"
                             :incrementationsPas="0.1">
                      <div class="control">
                        <a class="button is-static is-border is-square">
                          <span class="icon"><i class="fas fa-percentage"></i></span>
                        </a>
                      </div>
                    </v-input>
                  </div>
                </div>
                <div class="column is-3">
                  <div class="is-margin-bottom-xsmall">
                    <r-label :label="'Destination'" :redCheck='true' :value="adv.destination"></r-label>
                  </div>
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select class="" v-model="adv.destination">
                        <option :value="null">Sélectionner</option>
                        <option v-for="a in advDestinationsList" :key="a.value" :value="a.value">{{a.label}}</option>
                      </select>
                    </div>
                  </div>
                  <p v-if="destinationError" class="help is-danger">Le champ est obligatoire</p>
                </div>
                <div class="column is-3">
                  <r-label v-if="adv.destination === 'invest'" :label="'Dispositif'" :redCheck='true'
                           :value="adv.tax_dispositif"></r-label>
                  <label v-else for="tax_dispositif" class="label">Dispositif</label>
                  <div>
                    <div class="control">
                      <div class="select is-fullwidth">
                        <select v-model="adv.tax_dispositif"
                                :disabled="adv.destination !== 'invest' || !availableDispositifs"
                                :class="{'is-border' : adv.destination !== 'invest' || !availableDispositifs}">
                          <option :value="null" selected>Sélectionner</option>
                          <option v-for="a in availableDispositifs" :key="a.value" :value="a.value">{{a.label}}</option>
                          <option value="other" selected>Autre</option>
                        </select>
                      </div>
                    </div>
                    <p v-if="taxError" class="help is-danger">Le champ est obligatoire</p>
                  </div>
                </div>
                <div class="column is-3">
                  <div class="is-margin-bottom-xsmall">
                    <r-label :label="'Mandat de gestion'" :isRequired='false' :greenCheck='true'
                             :value="adv.mandat_de_gestion"></r-label>
                  </div>
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select class="" v-model="adv.mandat_de_gestion" id="mandat_de_gestion">
                        <option :value="null">NC</option>
                        <option :value="true">Oui</option>
                        <option :value="false">Non</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-min-height-50 is-flex is-border-top">
                <div class="is-self-centered"><span class="is-uppercase title is-6">Vendeur(s) / Mandataire(s)</span>
                </div>
              </div>

              <div class="columns has-bg-light is-border-top">
                <div class="column is-6">
                  <div
                    class="columns is-gapless is-vcentered has-text-primary is-padding-top-xsmall is-padding-bottom-xsmall">
                    <div class="column is-narrow is-margin-right">
                      <avatar :item="seller"></avatar>
                    </div>
                    <div class="column">
                      <span class="has-text-weight-medium">{{seller.first_name}} {{seller.last_name}}</span>
                      <br>
                      <span v-if="seller.company">Société {{seller.company_name}}</span>
                      <!-- <span class="is-size-6" v-if="seller && seller.remuneration && displayRemuneration">(COMM : {{seller.remuneration}}%)</span> -->
                      <span class="is-size-6" v-if="access && access.remuneration && displayRemuneration">(COMM : {{access.remuneration}}%)</span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-min-height-50 is-flex is-border-top is-border-bottom">
                <div class="is-self-centered"><span
                  class="is-uppercase title is-6">Réservataire(s) / Acquéreur(s)</span>
                </div>
              </div>
              <membre-adv :is-check="checkCompleteBuyer(buyer)" :is-grey="true" :membre="buyer" :is-promoteur="false" :is-co-acquereur="false" :modal-promoteur="false" :from-resa="true"></membre-adv>
              <membre-adv v-if="co_buyer" @DeleteCobuyer="beforeRemove" :is-grey="true" :is-check="checkCompleteBuyer(co_buyer)" :membre="co_buyer" :is-promoteur="false" :is-co-acquereur="true" :modal-promoteur="false" :from-resa="true"></membre-adv>
              <div
                class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-min-height-50 is-flex">
                <div class="is-self-centered"><span class="is-uppercase title is-6">Commentaire(s)</span></div>
              </div>
              <div class="field is-border-top is-padding-xsmall" @mouseover="displayToolbar = true"
                   @mouseleave="displayToolbar = false">
                <div class="control">
                  <!--<textarea class="textarea" type="text" placeholder="" v-model="adv.comment"></textarea>-->
                  <wysiwyg-editor :model="adv.comment"
                                  placeholder="" id="descText" name="descText"
                                  @change="val => adv.comment = val"
                                  :light-program='true' :light='true'
                                  :tooltip-top='true'
                                  :class="{'editr--hide-toolbar':!displayToolbar}"
                                  class="editr--bottom-toolbar editr--height-medium content"
                                  data-type-cy="wysiwyg-editor" data-value-cy="input_desc"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="column is-12 is-5-widescreen is-5-fullhd is-padding-left-xxsmall is-padding-right-xxsmall">
            <div class=" has-bg-white is-border">
              <adv-lot-compact :lot="lot" :program="program" v-if="lot && program" :display-button="false"/>
              <div v-if="lot.nature !== 'parking'" class="is-border-top has-bg-light is-padding">
                <div class="columns is-gapless">
                  <div class="column is-6">
                    <div class="control">
                      <div class="select is-fullwidth">
                        <select v-model='selectedPack' @change="updateSelectedPack(selectedPack)">
                          <option :value="null"> Prix immo TTC - {{lot.sale_price}} {{$currency}}</option>
                          <option v-if="lot.sale_price_less_parking || lot.sale_price_less_parking_ht"
                                  value="sans_parking">Prix TTC sans parking - {{lot.sale_price_less_parking}} {{$currency}}
                          </option>
                          <option class="is-uppercase" v-for="price in customPrices" :value="price.name"
                                  :key="price.name">{{price.name}} TTC - {{price.sale_price}} {{$currency}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="adv.custom_price_description" class="is-padding-top is-padding-bottom has-text-black-ter">
                  <b class="is-size-6" v-html="adv.custom_price_description"></b>
                </div>
              </div>

              <div class="is-border-top has-bg-light is-padding">
                <div class="columns is-gapless">
                  <div class="column columns is-gapless is-12">
                    <div class="column">
                      <r-label :label="'Prix immo du lot'" :redCheck='true' :value="adv.sale_price_ht"></r-label>
                      <div class="field has-addons">
                        <p class="control is-expanded">
                          <v-input id="sale_price_ht" :name="'sale_price_ht'" @input="val => updateSalePriceHt(val)"
                                   :model="adv.sale_price_ht"
                                   :number="true"
                                   input-type="number"
                                   :errors-bag="errors" data-vv-value-path="val" classes="has-text-right"
                                   data-vv-as=" " v-validate="'required|decimal:2'">
                          </v-input>
                        </p>
                        <div class="control"><a class="button is-static is-border is-square" :class="`is-currency-${$faCurrency}`"><b
                          class="">{{$currency}}&nbsp;HT</b></a></div>
                      </div>
                    </div>
                    <div class="column is-narrow w110p is-padding-left-small is-padding-right-small">
                      <r-label :redCheck='true' :label="'Tva'" :value="adv.tva"></r-label>
                      <div class="select is-transparent is-paddingless-left">
                        <select class="has-text-weight-medium" v-model.number="adv.tva"
                                @change="updateTva(adv.tva, adv.sale_price, null)">
                          <option :value="20.0">20.0%</option>
                          <option :value="10.0">10.0%</option>
                          <option :value="7.0">7.0%</option>
                          <option :value="5.5">5.5%</option>
                        </select>
                      </div>
                      <div class="has-text-weight-light has-text-black-ter is-size-6" v-if="tvaAmount">
                        ({{tvaAmount | prettyPrice}} {{$currency}})
                      </div>
                    </div>
                    <div class="column">
                      <r-label :label="'Prix immo TTC'" :redCheck='true' :value="adv.sale_price"></r-label>
                      <div class="field has-addons">
                        <p class="control is-expanded">
                          <v-input id="sale_price" :name="'sale_price'" @input="val => updateSalePrice(val)"
                                   :model="adv.sale_price"
                                   :errors-bag="errors" data-vv-value-path="val" classes="has-text-right"
                                   data-vv-as=" " v-validate="'required|decimal:2'">
                          </v-input>
                        </p>
                        <div class="control"><a class="button is-static is-border is-square" :class="`is-currency-${$faCurrency}`"><b class="">{{$currency}}&nbsp;TTC</b></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="parkings && parkings.length"
                   class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-min-height-50 is-flex is-border-top">
                <div class="is-self-centered"><span class="">Dont prix du (ou des) parking(s)</span></div>
              </div>
              <template v-for="(parking, idx) in parkings">
                <parking-item-resa :source="parking" :key="idx" :index='idx'></parking-item-resa>
              </template>
            </div>
          </div>

          <div
            class="column is-12 is-7-widescreen is-7-fullhd formActionsSticky is-bottom is-zindex-2 is-padding-left-xxsmall is-padding-right-xxsmall">
            <div class="columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
              <div class="column is-4 is-3-widescreen is-margin-right-small">
                <button class="button is-light is-uppercase is-fullwidth" @click="$router.goBack(route)">Annuler
                </button>
              </div>
              <div class="column is-4 is-3-widescreen is-margin-left-small">
                <button class="button is-success is-uppercase is-fullwidth has-text-white" :disabled="loadingSubmit"
                        @click="submit" :class="{'is-loading':loadingSubmit}">
                  <span v-if="!loadingSubmit">Création ADV</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MembreAdv from '../adv/MembreAdv'
  import { DefaultValues } from '@/mixins'
  import { debounce, cloneDeep } from 'lodash'
  import AdvLot from '../adv/Details/AdvLot'
  import AdvLotCompact from '../adv/Details/AdvLotCompact'
  import { mapGetters } from 'vuex'
  import ParkingItemResa from './ParkingItemResa'

  export default {
    name: 'ResaCreate',
    mixins: [DefaultValues],
    components: { AdvLot, AdvLotCompact, ParkingItemResa, MembreAdv },
    data () {
      return {
        option: {},
        buyer: {},
        seller: {},
        program: {},
        lot: {},
        tvaAmount: null,
        loading: false,
        adv: {
          mandat_de_gestion: null,
          destination: null,
          tva: 20.0,
          custom_price_name: null,
          custom_price_description: null,
          parkings: []
        },
        destinationError: null,
        parkingError: null,
        taxError: null,
        loadingSubmit: false,
        route: this.$route,
        access: null,
        displayToolbar: false,
        parkings: [],
        selectedPack: null,
        co_buyer: null
      }
    },
    computed: {
      ...mapGetters(['displayRemuneration', 'isDistributeurMode', 'currentUserCountry']),
      optionPk () {
        return this.$route.params.id
      },
      availableDispositifs () {
        return this.taxDispositifsList.filter(x => x.valid)
      },
      isCustomPrices () {
        return this.lot.custom_prices && this.lot.custom_prices.length
      },
      customPrices () {
        return this.lot.custom_prices
      },
      checkAdvParkings () {
        let parkingTrue = []
        this.parkings.forEach(parking => {
          if (parking.isCheck) {
            parkingTrue.push(parking)
          } else if (!parking.isCheck) {
            parkingTrue.push(parking)
          }
        })
        if (parkingTrue.length === this.parkings.length) {
          return true
        } else {
          return false
        }
      }
    },
    watch: {
      'adv.destination' (val, old) {
        if (val === null || val !== 'invest') {
          this.$set(this.adv, 'tax_dispositif', null)
        }
      }
    },
    methods: {
      beforeRemove (val) {
        this.$swal({
          title: 'Acquéreur',
          text: 'Souhaitez-vous vraiment retirer cet acquéreur ?',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Annuler',
          cancelButtonColor: '#ff0200',
          showCloseButton: true
        }).then(res => {
          console.log(res)
          if (res.value) {
            this.removeCoBuyer(val)
          }
        })
      },
      removeCoBuyer () {
        this.co_buyer = null
      },
      addressContactIsValid (address) {
        if (this.currentUserCountry === 'FRA') {
          return address !== null && address !== '' &&
          address.line1 !== null && address.line1 !== '' &&
          address.zip_code !== null && address.zip_code !== '' &&
          address.city !== null && address.city !== ''
        } else {
          return address !== null && address !== '' &&
            address.zip_code !== null && address.zip_code !== '' &&
            address.city !== null && address.city !== ''
        }
      },
      checkCompleteBuyer (buyer) {
        if (!buyer) return
        if (!buyer.address) return
        if (buyer.nature === 'corporation') {
          return (buyer.corporation_name !== null || buyer.corporation_name !== '') &&
            (buyer.corporation_siret !== null || buyer.corporation_siret !== '') &&
            buyer.last_name !== null && buyer.last_name !== '' &&
            buyer.first_name !== null && buyer.first_name !== '' &&
            buyer.birth_name !== null && buyer.birth_name !== '' &&
            this.addressContactIsValid(buyer.address) &&
            (buyer.csp === 'unemployed' || buyer.csp === 'retirement'
              ? true : buyer.profession !== null && buyer.profession !== '')
        } else {
          return buyer.last_name !== null && buyer.last_name !== '' &&
            buyer.birth_name !== null && buyer.birth_name !== '' &&
            buyer.first_name !== null && buyer.first_name !== '' &&
            this.addressContactIsValid(buyer.address) &&
            buyer.birthday !== null && buyer.birthday !== '' &&
            buyer.nationality !== null && buyer.nationality !== '' &&
            buyer.birthplace !== null && buyer.birthplace !== '' &&
            (buyer.csp === 'unemployed' || buyer.csp === 'retirement'
              ? true : buyer.profession !== null && buyer.profession !== '') &&
            (buyer.family_situation === 'married'
              ? (buyer.matrimonial_status !== null && buyer.matrimonial_status !== '') : true) &&
            (buyer.family_situation === 'pacs'
              ? (buyer.matrimonial_status !== null && buyer.matrimonial_status !== '') : true)
        }
      },
      updateSelectedPack (value) {
        if (value !== null && value !== 'sans_parking') {
          this.$set(this.adv, 'custom_price_name', value)
          let selectPack = this.customPrices.find(x => {
            return x.name === this.adv.custom_price_name
          })
          console.log(selectPack)
          if (selectPack === undefined) {
            this.$set(this.adv, 'custom_price_description', null)
          } else {
            this.$set(this.adv, 'custom_price_description', selectPack.description)
          }
          this.$set(this.adv, 'sale_price', selectPack.sale_price)
          this.$set(this.adv, 'sale_price_ht', selectPack.sale_price_ht)
        } else if (value === 'sans_parking') {
          if (this.adv.custom_price_name) this.$set(this.adv, 'custom_price_name', null)
          if (this.adv.custom_price_description) this.$set(this.adv, 'custom_price_description', null)
          this.$set(this.adv, 'sale_price', this.lot.sale_price_less_parking)
          this.$set(this.adv, 'sale_price_ht', this.lot.sale_price_less_parking_ht)
        } else {
          if (this.adv.custom_price_name) this.$set(this.adv, 'custom_price_name', null)
          if (this.adv.custom_price_description) this.$set(this.adv, 'custom_price_description', null)
          this.$set(this.adv, 'sale_price', this.lot.sale_price)
          this.$set(this.adv, 'sale_price_ht', this.lot.sale_price_ht)
        }
        this.updateTva()
      },
      getOption () {
        this.loading = true
        this.$api.optionService.getOne(this.optionPk).then(r => {
          this.option = r.data
          this.adv.option = r.data.pk
          this.getLot(r.data.lot)
          this.getProgram(r.data.program)
          this.getSeller(r.data.seller)
          this.getBuyer(r.data.buyer)
          this.loading = false
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            message: 'Impossible de récupérer l\'option'
          })
        })
      },
      getSeller (id) {
        this.loading = true
        this.$api.userService.getOne(id).then(r => {
          this.loading = false
          this.seller = r.data
          if (this.seller.is_external && this.program.pk) {
            this.getAccess(this.seller.company.pk || this.seller.company, this.program.pk, this.program.promoteur.pk)
          }
        }).catch(() => {
          this.loading = false
        })
      },
      getBuyer (id) {
        this.loading = true
        this.$api.contactService.getOne(id).then(r => {
          this.loading = false
          this.buyer = r.data
          if (this.buyer.spouse) {
            this.getCobuyer(this.buyer.spouse)
          }
        }).catch(() => {
          this.loading = false
        })
      },
      getCobuyer (id) {
        this.loading = true
        this.$api.contactService.getOne(id).then(r => {
          this.loading = false
          this.co_buyer = r.data
        }).catch(() => {
          this.loading = false
        })
      },
      getLot (id) {
        this.loading = true
        this.$api.lotService.getOne(id).then(r => {
          this.loading = false
          this.lot = r.data
          if (r.data.sale_price) {
            this.adv.sale_price = r.data.sale_price
          } else if (!r.data.sale_price && r.data.sale_price_ht) {
            this.updateSalePriceHt(r.data.sale_price_ht)
          }
          if (r.data.sale_price_ht) {
            this.adv.sale_price_ht = r.data.sale_price_ht
          } else if (!r.data.sale_price_ht && r.data.sale_price) {
            this.updateSalePrice(r.data.sale_price)
          }
          if (r.data.annexes) {
            let parkings = []
            r.data.annexes.forEach(x => {
              if (x.is_parking) {
                let parking = {
                  annex_type: x.annex_type,
                  info: x.info,
                  isCheck: true,
                  tva: 20.0
                }
                parkings.push(parking)
              }
            })
            if (parkings && parkings.length) this.$set(this, 'parkings', parkings)
          }
          // if (this.lot.tax_dispositifs && this.lot.tax_dispositifs.length === 1) {
          //   this.adv.tax_dispositif = this.lot.tax_dispositifs[0]
          // }
          this.updateTva()
        }).catch(() => {
          this.loading = false
        })
      },
      getProgram (id) {
        this.loading = true
        this.$api.programService.getOne(id).then(r => {
          this.loading = false
          this.program = r.data
          this.adv.program_remuneration = r.data.remuneration
          this.getAccess(this.seller.company.pk || this.seller.company, this.program.pk)
        }).catch(() => {
          this.loading = false
        })
      },
      getAccess (company, program, promoteur) {
        let query = {
          program,
          company,
          per_page: 1
        }
        let query2 = {
          company,
          promoteur,
          per_page: 1
        }

        this.$api.accessService.get(query).then(r => {
          if (r.data.items.length) {
            this.access = r.data.items[0]
          } else if (r.data.items.length === 0 && this.isDistributeurMode) {
            this.$api.accessService.getPromoteurAccess(query2).then(r => {
              if (r.data.items.length) {
                this.access = r.data.items[0]
              }
            })
          }
        })
      },
      updateSalePrice: debounce(function (valSalePrice) {
        let salePriceTTC, salePriceHT
        if (!this.adv.sale_price || Number(valSalePrice) !== Number(this.adv.sale_price)) {
          salePriceTTC = valSalePrice
          salePriceHT = salePriceTTC / (1 + (this.adv.tva / 100))
          salePriceHT = salePriceHT.toFixed(2)
        }
        this.updatePrice(salePriceTTC, salePriceHT)
      }, 500),
      updateSalePriceHt: debounce(function (valSalePriceHt) {
        let salePriceTTC, salePriceHT
        if (!this.adv.sale_price_ht || Number(valSalePriceHt) !== Number(this.adv.sale_price_ht)) {
          salePriceHT = valSalePriceHt
          salePriceTTC = salePriceHT * (1 + (this.adv.tva / 100))
          salePriceTTC = salePriceTTC.toFixed(2)
        }
        this.updatePrice(salePriceTTC, salePriceHT)
      }, 500),
      updatePrice (salePriceTTC, salePriceHT) {
        if (salePriceTTC) this.$set(this.adv, 'sale_price', salePriceTTC)
        if (salePriceHT) this.$set(this.adv, 'sale_price_ht', salePriceHT)
        this.$set(this, 'tvaAmount', Number(this.adv.sale_price) - Number(this.adv.sale_price_ht))
      },
      updateTva (val) {
        if (val) this.$set(this.adv, 'tva', val)
        let tva = this.adv.tva

        let salePriceTTC = Number(this.adv.sale_price)
        let salePriceHT = Number(this.adv.sale_price_ht)

        if (!salePriceTTC && salePriceHT) {
          salePriceTTC = salePriceHT * (1 + (tva / 100))
          salePriceTTC = salePriceTTC.toFixed(2)
        } else {
          salePriceHT = salePriceTTC / (1 + (tva / 100))
          salePriceHT = salePriceHT.toFixed(2)
        }
        this.updatePrice(salePriceTTC, salePriceHT)
      },
      submit () {
        this.$validator.validateAll().then(isValid => {
          if (!this.adv.destination) {
            this.$notify({
              type: 'is-danger',
              text: 'Oups ! Merci de compléter les champs obligatoires.'
            })
            return this.$set(this, 'destinationError', true)
          } else if (this.adv.destination && this.adv.destination === 'invest' && !this.adv.tax_dispositif) {
            this.$notify({
              type: 'is-danger',
              text: 'Oups ! Merci de compléter les champs obligatoires.'
            })
            this.$set(this, 'taxError', true)
            return this.$set(this, 'destinationError', false)
          } else if (!this.checkAdvParkings) {
            this.$notify({
              type: 'is-danger',
              text: 'Oups ! Merci de compléter les champs obligatoires.'
            })
            return this.$set(this, 'parkingError', true)
          } else {
            this.$set(this, 'destinationError', false)
            this.$set(this, 'taxError', false)
          }
          if (isValid) {
            this.$set(this.adv, 'parkings', [])
            this.parkings.forEach(x => {
              if (x.isCheck === true) {
                let parking = cloneDeep(x)
                delete parking.isCheck
                this.adv.parkings.push(parking)
              }
            })
            this.$set(this, 'destinationError', false)
            this.$set(this, 'taxError', false)
            this.loadingSubmit = true
            let data = Object.assign({}, this.adv)
            if (this.co_buyer) {
              data.co_buyer = this.co_buyer.pk
            }
            this.$api.advService.post(data).then(r => {
              this.loadingSubmit = false
              this.$router.push({ name: 'AdvInfos', params: { id: r.data.pk } })
              this.$notify({
                type: 'is-success',
                text: 'L\'adv a bien été crée.'
              })
            }).catch(() => {
              this.loadingSubmit = false
              this.$notify({
                type: 'is-danger',
                text: 'Impossible de créer l\'adv.'
              })
            })
          } else {
            this.$notify({
              type: 'is-danger',
              text: 'Oups ! Merci de compléter les champs obligatoires.'
            })
          }
        })
      }
    },
    created () {
      this.getOption()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/option/ResaCreate.vue